import { Box, Flex, Text, HStack } from '@chakra-ui/react';
import { useAddress } from '@thirdweb-dev/react';
import React, { useMemo, useState } from 'react';

import { Search } from '@app/components/Search';
import { usePositionsListData } from '@app/hooks/positions/usePositionsListData';
import { ListLoader } from '@app/screens/pools/components/ListLoader';
import { PositionsListHeader } from '@app/screens/positions/components/PositionsListHeader';
import { PositionsListRow } from '@app/screens/positions/components/PositionsListRow/PositionsListRow';

import s from './PositionsList.module.scss';
import { CreatePositionButton } from '@app/screens/positions/components/CreatePositionButton';
import { usePairsDayData } from '@app/hooks/pair/usePairsDayData';
import { useHideOnUnmount } from '@app/hooks/other/useHideOnUnmount';
import { Icon } from '@app/components/Icon';

const ITEMS_PER_PAGE = 100;

export const PositionsList = () => {
  const address = useAddress();

  const { data, isLoading } = usePositionsListData({
    skip: 0,
    first: ITEMS_PER_PAGE,
    address: address ? address.toLowerCase() : ''
  });

  const ids = data
    ? data
        .map(({ pair }) => {
          return `"${pair.id}"`;
        })
        .join(',')
    : undefined;

  const { data: pairsDayData } = usePairsDayData({
    ids
  });

  function renderList() {
    if (isLoading) {
      return <ListLoader />;
    }

    if (!data || data.length === 0) {
      return (
        <Flex
          minHeight="160px"
          width="100%"
          align="center"
          justify="center"
          flexDirection="column"
          className={s.noData}
        >
          <Icon name="noData" style={{ width: 56, height: 56 }} />
          <div className={s.noDataMessage}>
            Your liquidity will be shown here.
          </div>
        </Flex>
      );
    }

    return (
      <>
        {data?.map(item => {
          const dayData = pairsDayData?.filter(p => p.pairAddress === item.id);

          return (
            <PositionsListRow key={item.id} item={item} dayData={dayData} />
          );
        })}
      </>
    );
  }

  const { display } = useHideOnUnmount();

  if (!display) {
    return null;
  }

  return <Box className={s.container}>{renderList()}</Box>;
};
